const Routes = {
  '': 'Play',
  print: 'Print',
  about: 'About',
  question: 'Add Question',
  donate: 'Donate',
}

export default Routes
